import React from 'react'

export function ConsentBanner() {
  const [visible, setVisible] = React.useState(() => {
    if (typeof window === 'undefined') return false
    const v = localStorage.getItem('analytics_consent')
    return v !== 'accepted' && v !== 'rejected'
  })

  React.useEffect(() => {
    const handler = () => setVisible(true)
    window.addEventListener('open-analytics-consent', handler)
    return () => window.removeEventListener('open-analytics-consent', handler)
  }, [])

  if (!visible) return null

  const accept = () => {
    try {
      localStorage.setItem('analytics_consent', 'accepted')
      localStorage.setItem('n8n2py_analytics_consent', 'accepted')
      // Load GA now that consent is given
      const s = document.createElement('script')
      s.async = true
      s.src = 'https://www.googletagmanager.com/gtag/js?id=G-0Y3ZR1N8MH'
      document.head.appendChild(s)
    } catch {}
    setVisible(false)
  }
  const decline = () => {
    try { localStorage.setItem('analytics_consent', 'rejected') } catch {}
    setVisible(false)
  }

  return (
    <div className="fixed bottom-4 inset-x-0 z-50 flex justify-center px-4 animate-in slide-in-from-bottom-4 duration-300">
      <div className="max-w-3xl w-full bg-background/95 backdrop-blur border rounded-lg shadow-lg p-4">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-sm text-muted-foreground">
            We use anonymized analytics to improve the site. You can opt out. Read our
            {' '}<a href="/privacy" className="underline hover:text-foreground transition-colors">Privacy Policy</a>.
          </p>
          <div className="flex gap-2 w-full sm:w-auto">
            <button
              onClick={decline}
              className="px-4 py-2 text-sm border rounded-md cursor-pointer transition-all duration-200 hover:bg-muted hover:border-foreground/30 active:scale-[0.97] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
            >
              Decline
            </button>
            <button
              onClick={accept}
              className="px-4 py-2 text-sm bg-primary text-primary-foreground rounded-md cursor-pointer transition-all duration-200 hover:bg-primary/90 active:scale-[0.97] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
            >
              Accept
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
